import { toast, ToastOptions } from 'react-toastify'

export const successToast = (message: string, options?: ToastOptions) => {
  toast.success(message, {
    autoClose: 5000,
    ...options,
  })
}
